import i18next from '../../config/i18next';
import i18nUser from './i18n/fr.json';

import FeedbackPage from './pages/feedback-page';

i18next.addResourceBundle('fr', 'users-feedback', i18nUser);

export { FeedbackPage };
